// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__18Idh","buttons":"RemoveExpirationActionButtons_buttons__WCndX"};